module.exports = __webpack_public_path__ + "img/paint-brush-fine.b203b83f.svg";